/**
 * Enum representing the possible archive statuses for filtering conversations
 */
export enum ArchiveStatus {
  /** Show all conversations regardless of archive status */
  ALL = 'all',
  /** Show only active (non-archived) conversations */
  ACTIVE = 'active',
  /** Show only archived conversations */
  ARCHIVED = 'archived',
}

/**
 * Array of options for archive status filtering in UI components
 *
 * TODO: check when implementing i18n
 */
export const ARCHIVE_STATUS_OPTIONS = [
  { value: ArchiveStatus.ALL, label: 'Todas' },
  { value: ArchiveStatus.ACTIVE, label: 'Activas' },
  { value: ArchiveStatus.ARCHIVED, label: 'Archivadas' },
];

/**
 * Enum representing the possible directions for last interaction filtering
 */
export enum InteractionDirection {
  /** Incoming interactions (received) */
  INCOMING = 'incoming',
  /** Outgoing interactions (sent) */
  OUTGOING = 'outgoing',
}

/**
 * Array of options for interaction direction filtering in UI components
 *
 * TODO: check when implementing i18n
 */
export const INTERACTION_DIRECTION_OPTIONS = [
  { value: InteractionDirection.INCOMING, label: 'Entrante' },
  { value: InteractionDirection.OUTGOING, label: 'Saliente' },
];
